import type { LabelData } from './labels';

export interface LabelResponse {
  data: string[];
  total: number;
}
export interface LabelPerfResponse {
  tracks: number;
  tracks_need_review: number;

  opportunity_revenue_from_fixes: number;

  monthly_revenue: number;
  monthly_revenue_trend: number;
  monthly_streams: number;
  monthly_streams_trend: number;

  monthly_revenue_from_fixes: number;
  monthly_revenue_trend_from_fixes: number;
  monthly_streams_from_fixes: number;
  monthly_streams_trend_from_fixes: number;
}

export interface LabelPerfModel {
  totalAssets: number;
  totalGaps: number;
  overallMonthlyRevenue: number;
  overallMonthlyRevenueChange: number;
  overallMonthlyStreams: number;
  overallMonthlyStreamsChange: number;
  opportunityRevenueFromFixes: number;
  revenueFromFixes: number;
  revenueFromFixesChange: number;
  streamsFromFixes: number;
  streamsFromFixesChange: number;
}

export interface TrackResponse {
  isrc: string;
  artist: string;
  track_title: string;

  revenue_value: number;
  revenue_trend: number;

  streams_value: number;
  streams_trend: number;
}

export interface MonthlyContribResponse {
  date: string;
  total_streams: number;
  total_revenue: number;
  total_fixes: number;
}

export interface MonthlyContrib {
  date: Date;
  totalStreams: number;
  totalRevenue: number;
  fixesCount: number;
}

export interface TrackItem {
  trackName: string;
  artistName: string;
  isrc: string;
  revenue: number;
  revenueChange: number;
  streams: number;
  streamsChange: number;
}

export interface Artist {
  name: string;
  uaid: number;
  partyId: number | null;
  formatCode: string;
  familySplit: number;
}
export interface RelatedArtist {
  name: string;
  uaid: number;
  partyId?: number;
}

export interface TrackPerformanceResponse {
  family_id: string;
  family_title: string;
  family_description: string;
  isrc_list: string[];
  artist: {
    name: string;
    uaid: number;
    party_id: number | null;
    format_code: string;
    family_split: number;
  };
  release_date: string;
  pct_streams_ad_supported: number;
  pct_streams_paid: number;
  pct_streams_amazon: number;
  pct_streams_apple: number;
  pct_streams_spotify: number;
  pct_streams_youtube: number;
  pct_streams_other: number;
  major_labels: string[];
  related_artists: {
    name: string;
    uaid: number;
    party_id: number;
  }[];
  streams_rtd: number;
  streams_tw: number;
  streams_lw: number;
  streams_wow: number;
  social_creations_tw: number;
  social_creations_lw: number;
  social_creations_wow: number;
  organic_streams_tw: number;
  organic_streams_lw: number;
  organic_streams_wow: number;
}

export interface PerformanceStats {
  streamsRtd: number;
  streamsTw: number;
  streamsLw: number;
  streamsWow: number;
  socialCreationsTw: number;
  socialCreationsLw: number;
  socialCreationsWow: number;
  organicStreamsTw: number;
  organicStreamsLw: number;
  organicStreamsWow: number;
}

export interface PlatformsStats {
  pctStreamsAdSupported: number;
  pctStreamsPaid: number;
  pctStreamsAmazon: number;
  pctStreamsApple: number;
  pctStreamsSpotify: number;
  pctStreamsYoutube: number;
  pctStreamsOther: number;
}

export interface TrackPerformanceItem extends PerformanceStats, PlatformsStats {
  familyId: string;
  familyTitle: string;
  familyDescription: string;
  isrcList: string[];
  artist: Artist;
  releaseDate: string;

  majorLabels: string[];
  relatedArtists: RelatedArtist[];
}

export interface FixesHistResponseValue {
  date: string;
  tracks_to_investigate: number;
  fixed_tracks: number;
  active_track_locks: number;
}

export interface FixesHistValue {
  name: string;
  inReview: number;
  fixed: number;
  needFixes: number;
}

export type HistRange = 'week' | 'month' | 'year' | 'allTime';

export type TopTenType = 'revenue' | 'streams';
export type TopTenOrder = 'top' | 'bottom';

export enum TopTenCategory {
  RevenueUp = 'revenueUp',
  StreamsUp = 'streamsUp',
  RevenueDown = 'revenueDown',
  StreamsDown = 'streamsDown',
}

export type TopTenVariant =
  | 'revenueUp'
  | 'streamsUp'
  | 'revenueDown'
  | 'streamsDown';

// TREND
export type Direction = 'up' | 'down' | 'none';

// LEGEND
export enum LegendColor {
  NeedsReview = '#FE4AC3',
  InReview = '#F1830E',
  FixedTracks = '#FFB800',
}

export enum LegendName {
  NeedsReview = 'Needs Review',
  InReview = 'In Review',
  FixedTracks = 'Fixed Tracks',
}

export interface LabelPerfFilters {
  labels: LabelData[];
  isCrossover: boolean;
  isOnRoster?: boolean;
}

export interface MixOnePerformanceResp {
  tracks: {
    family_id: string;
    streaming_by_dsp: {
      total_streams: number;
      this_period_streams: number;
      previous_period_streams: number;
      this_period_organic_streams: number;
      previous_period_organic_streams: number;
    }[];
    engagement_by_dsp: {
      this_period_social_creations: number;
      previous_period_social_creations: number;
    }[];
  }[];
}
